export default {
  socketUrl: `${process.env.REACT_APP_SOCKET_URL}`,
  baseUrl: `${process.env.REACT_APP_API_URL}/api`,
  conversionApiUrl: `${process.env.REACT_APP_CONVERSION_API_URL}`,
  getBotParameters: '/bot/getParameters',
  getAllAgents: '/agent/all',
  getAllBots: '/bot/all',
  getAllBotNames: '/bot/all/names',
  getBotDetails: '/bot/details',
  deleteBot: '/bot/delete',
  updateBot: '/bot/update',
  downloadBotFile: '/bot/downloadXAML',
  getAllRoles: '/role/all',
  getAllUsers: '/user/all',
  getUserDetails: '/user/details',
  getUserGroupDetails: '/user/groupDetails',
  deleteUser: '/user/delete',
  updateUser: '/user/update',
  getUserNames: '/user/names',
  getAllProcess: '/process/all',
  getAllSchedule: '/process/schedule/log/all',
  createProcess: '/process/create',
  scheduleProcess: '/process/schedule',
  scheduleProcessHistory: '/process/schedule/history',
  cancelCurrentProcess: '/process/cancel',
  createBot: '/bot/create',
  getProcessLogs: '/process/transaction-logs',
  getProcessExecutionLogs: '/processExecutionLog',
  login: '/user/login',
  register: '/user/register',
  agentSetupFile: '/agent/download',
  registerCompany: '/company/create',
  getAgentsByCompany: '/company/{id}/agents',
  getBotsByCompany: '/company/{id}/bots',
  getAllCompanies: '/company/all',
  getCompaniesName: '/company/names',
  updateCompany: '/company/update',
  getCompanyDetails: '/company/details',
  deleteCompany: '/company/delete',
  forgotPassword: '/account/forgot-password',
  resetPassword: '/account/reset-password',
  companyGenerateToken: '/registrationToken/generate',
  getAllTokens: '/registrationToken/all',
  deleteRegistrationToken: '/registrationToken/delete',
  getDataForBotPerformance: '/dashboard-report/bot-performance',
  getDataForLineGraph: '/dashboard-report/line-graph',
  getDataForSunburstChart: '/dashboard-report/sunburst-chart',
  getDataForScheduledPercentage: '/dashboard-report/schedule-summary',
  getDataForBarGraph: '/dashboard-report/bar-graph',
  deleteAgent: '/agent/delete',
  sendResetPasswordLinkOnBlockedAccount: '/user/resetpassword',
  createGroup: '/groups/create',
  getGroupsByPagination: '/groups/by-pagination',
  getById: '/groups/details',
  deleteGroup: '/groups/delete',
  getGroupsName: '/groups/names',
  bulkAssociation: '/groups/bulk-association',
  bookDemo: '/bookDemo',
  priceDetails:'/priceDetails',
  priceDetailsDefaults: '/priceDetails/defaults',
  updateGroup: '/groups/update',
  getAgentsName: '/agent/all/names',
  bulkCancellationOfPendingProcesses: '/process/bulk-cancel',
  getAllHostNames: '/emailSchedule/all/names',
  addNewEmailConfig: '/emailSchedule/create',
  checkConnectionEmailConfig: '/emailSchedule/check-connection',
  getAllEmailConfig: '/emailSchedule/all',
  deleteEmailConfig: '/emailSchedule/delete',
  updateEmailConfig: '/emailSchedule/update',
  queueMessages: '/queue/queue',
  addCompanyLicense: '/companyLicense/create',
  addBotStudioSubscription: '/botStudio/createBotStudioSubscription',
  studioSetupFile: '/studio/download',
};
